<template>
  <div class="contact max-w-4xl mx-auto">
    <div class="glass-card p-8">
      <!-- 헤더 -->
      <div class="text-center mb-8">
        <div class="text-4xl mb-3">📧</div>
        <h1 class="text-3xl font-bold text-gradient mb-2">문의하기</h1>
        <p class="text-gray-600">궁금한 점이나 제안사항이 있으신가요?</p>
      </div>

      <!-- 빠른 도움말 -->
      <section class="mb-8">
        <div class="bg-blue-50 p-6 rounded-xl border-l-4 border-blue-400">
          <h2 class="font-bold text-lg mb-3 flex items-center">
            <span class="text-2xl mr-2">💡</span>
            빠른 도움말
          </h2>
          <p class="text-gray-700 mb-3">
            문의하시기 전에 아래 자주 묻는 질문들을 먼저 확인해 주세요!
          </p>
          <div class="space-y-2 text-sm">
            <details class="bg-white p-3 rounded cursor-pointer">
              <summary class="font-semibold">Q. AI가 정말 당첨 확률을 높여주나요?</summary>
              <p class="mt-2 text-gray-600">
                아니요. 모든 번호 조합의 당첨 확률은 1/8,145,060로 동일합니다. 
                AI와 패턴은 순전히 재미를 위한 것이며, 당첨 확률을 높일 수 없습니다.
              </p>
            </details>
            <details class="bg-white p-3 rounded cursor-pointer">
              <summary class="font-semibold">Q. 서비스는 무료인가요?</summary>
              <p class="mt-2 text-gray-600">
                네! 로또 지니어스는 완전 무료이며, 회원가입도 필요 없습니다.
              </p>
            </details>
            <details class="bg-white p-3 rounded cursor-pointer">
              <summary class="font-semibold">Q. 데이터는 어디서 가져오나요?</summary>
              <p class="mt-2 text-gray-600">
                동행복권 공식 API를 통해 매일 자동으로 최신 당첨번호 데이터를 수집합니다.
              </p>
            </details>
          </div>
        </div>
      </section>

      <!-- 문의 유형 -->
      <section class="mb-8">
        <h2 class="text-2xl font-bold mb-6 text-blue-600">문의 유형</h2>
        <div class="grid md:grid-cols-2 gap-4">
          <div class="bg-gradient-to-br from-green-50 to-emerald-50 p-5 rounded-xl border border-green-200">
            <div class="text-3xl mb-2">🐛</div>
            <h3 class="font-bold text-lg mb-2">버그 리포트</h3>
            <p class="text-sm text-gray-700 mb-3">
              서비스 이용 중 오류나 문제를 발견하셨나요? 
              상세한 상황 설명과 함께 알려주세요.
            </p>
            <ul class="text-xs text-gray-600 space-y-1">
              <li>• 발생한 오류 메시지</li>
              <li>• 사용 중인 브라우저와 기기</li>
              <li>• 문제가 발생한 상황</li>
            </ul>
          </div>

          <div class="bg-gradient-to-br from-purple-50 to-pink-50 p-5 rounded-xl border border-purple-200">
            <div class="text-3xl mb-2">💡</div>
            <h3 class="font-bold text-lg mb-2">기능 제안</h3>
            <p class="text-sm text-gray-700 mb-3">
              새로운 AI 캐릭터나 패턴 아이디어가 있으신가요? 
              여러분의 창의적인 제안을 기다립니다!
            </p>
            <ul class="text-xs text-gray-600 space-y-1">
              <li>• 추가했으면 하는 기능</li>
              <li>• 개선이 필요한 부분</li>
              <li>• 새로운 패턴 아이디어</li>
            </ul>
          </div>

          <div class="bg-gradient-to-br from-blue-50 to-cyan-50 p-5 rounded-xl border border-blue-200">
            <div class="text-3xl mb-2">❓</div>
            <h3 class="font-bold text-lg mb-2">일반 문의</h3>
            <p class="text-sm text-gray-700 mb-3">
              서비스 사용법이나 기능에 대해 궁금한 점이 있으신가요?
            </p>
            <ul class="text-xs text-gray-600 space-y-1">
              <li>• 서비스 이용 방법</li>
              <li>• 기능 설명</li>
              <li>• 기타 질문</li>
            </ul>
          </div>

          <div class="bg-gradient-to-br from-orange-50 to-amber-50 p-5 rounded-xl border border-orange-200">
            <div class="text-3xl mb-2">🤝</div>
            <h3 class="font-bold text-lg mb-2">협업 제안</h3>
            <p class="text-sm text-gray-700 mb-3">
              파트너십이나 협업 제안이 있으시다면 언제든 연락주세요.
            </p>
            <ul class="text-xs text-gray-600 space-y-1">
              <li>• 광고 및 마케팅 협력</li>
              <li>• 데이터 제휴</li>
              <li>• 기타 제안</li>
            </ul>
          </div>
        </div>
      </section>

      <!-- 문의 방법 -->
      <section class="mb-8">
        <h2 class="text-2xl font-bold mb-6 text-blue-600">문의 방법</h2>

        <!-- 이메일 -->
        <div class="bg-blue-50 p-6 rounded-xl">
          <div class="flex items-start">
            <div class="text-4xl mr-4">📧</div>
            <div class="flex-1">
              <h3 class="font-bold text-lg mb-2">이메일 문의</h3>
              <p class="text-gray-700 mb-3">
                궁금하신 점이나 제안사항이 있으시면 이메일로 보내주세요.
              </p>
              <div class="bg-white p-4 rounded-lg">
                <p class="text-sm text-gray-600 mb-2">문의 이메일:</p>
                <a
                  href="mailto:support@lottogenius.com"
                  class="text-blue-600 font-mono text-lg hover:underline"
                >
                  support@lottogenius.com
                </a>
              </div>
              <div class="mt-4 text-sm text-gray-600">
                <p class="mb-2">📝 이메일 작성 팁:</p>
                <ul class="list-disc list-inside space-y-1 ml-4">
                  <li>명확한 제목을 사용해 주세요</li>
                  <li>문제 상황을 자세히 설명해 주세요</li>
                  <li>스크린샷이 있으면 첨부해 주세요</li>
                  <li>2-3 영업일 내 답변 드립니다</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- 응답 시간 -->
      <section class="mb-8">
        <div class="bg-yellow-50 p-5 rounded-xl border-l-4 border-yellow-400">
          <h3 class="font-bold text-lg mb-2 flex items-center">
            <span class="text-2xl mr-2">⏰</span>
            응답 시간
          </h3>
          <ul class="space-y-2 text-sm text-gray-700">
            <li>
              <strong>긴급 버그:</strong> 24시간 이내 (서비스 중단 등 심각한 오류)
            </li>
            <li>
              <strong>일반 문의:</strong> 2-3 영업일 이내
            </li>
            <li>
              <strong>기능 제안:</strong> 검토 후 개별 안내 (구현 여부는 우선순위에 따라 결정)
            </li>
          </ul>
        </div>
      </section>

      <!-- 금지 사항 -->
      <section class="mb-8">
        <div class="bg-red-50 p-5 rounded-xl border-l-4 border-red-400">
          <h3 class="font-bold text-lg mb-2 flex items-center text-red-700">
            <span class="text-2xl mr-2">🚫</span>
            다음 문의는 답변드리기 어렵습니다
          </h3>
          <ul class="space-y-2 text-sm text-red-600">
            <li>• 당첨 번호 예측 요청</li>
            <li>• "이번 주 당첨 번호가 뭔가요?" 등의 질문</li>
            <li>• AI가 생성한 번호로 당첨되지 않았다는 불만</li>
            <li>• 로또 구매로 인한 금전적 손실 보상 요구</li>
            <li>• 비방, 욕설, 스팸성 메시지</li>
          </ul>
          <p class="text-sm text-gray-600 mt-3">
            ⚠️ 다시 한 번 강조합니다: 모든 번호의 당첨 확률은 동일하며, 
            본 서비스는 순전히 엔터테인먼트 목적입니다.
          </p>
        </div>
      </section>

      <!-- 커뮤니티 -->
      <section>
        <h2 class="text-2xl font-bold mb-6 text-blue-600">함께 만들어가요</h2>
        <div class="bg-gradient-to-br from-indigo-50 to-purple-50 p-6 rounded-xl text-center">
          <div class="text-4xl mb-3">💬</div>
          <p class="text-gray-700 mb-4">
            로또 지니어스는 사용자 여러분의 피드백과 제안으로 더욱 발전합니다.
            이메일을 통해 여러분의 소중한 의견을 들려주세요!
          </p>
          <a
            href="mailto:support@lottogenius.com"
            class="inline-block px-6 py-3 bg-gradient-to-r from-blue-600 to-purple-600 text-white rounded-lg hover:shadow-lg transition-all duration-300"
          >
            의견 보내기 →
          </a>
        </div>
      </section>

      <!-- 감사 메시지 -->
      <section class="mt-8">
        <div class="bg-gradient-to-r from-blue-500 to-purple-600 p-6 rounded-xl text-center text-white">
          <div class="text-4xl mb-3">🙏</div>
          <h3 class="text-xl font-bold mb-2">감사합니다!</h3>
          <p class="text-blue-100">
            여러분의 피드백이 로또 지니어스를 더 재미있고 유용하게 만듭니다. 
            모든 의견에 진심으로 감사드립니다.
          </p>
        </div>
      </section>
    </div>
  </div>
</template>

<script setup>
// 스크립트가 필요하면 추가
</script>

<style scoped>
.text-gradient {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.glass-card {
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(20px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  border-radius: 1rem;
}

section {
  scroll-margin-top: 100px;
}

details summary {
  list-style: none;
}

details summary::-webkit-details-marker {
  display: none;
}

details[open] summary {
  color: #2563eb;
}
</style>
